export const en = {
  questions: 'Questions',
  resetQuestions: 'Reset Questions',
  uploadQuestions: 'Upload Questions',
  removeQuestions: 'Remove Questions',
  assignQuestions: 'Assign Questions',
  enableTrivia: 'Enable Trivia',
};
